import { render, staticRenderFns } from "./Setup_Service.vue?vue&type=template&id=23fdbe76&scoped=true&"
import script from "./Setup_Service.vue?vue&type=script&lang=js&"
export * from "./Setup_Service.vue?vue&type=script&lang=js&"
import style0 from "./Setup_Service.vue?vue&type=style&index=0&id=23fdbe76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fdbe76",
  null
  
)

export default component.exports